import config from './config';

const api = {
  appointmentPrices: `${config[process.env.APP_ENV].apiUrl}/api/appointment-prices`,
  availabilities: `${config[process.env.APP_ENV].apiUrl}/api/availabilities`,
  availableClinicIds: `${config[process.env.APP_ENV].apiUrl}/api/available-clinics`,
  clinics: `${config[process.env.APP_ENV].apiUrl}/api/clinics`,
  customer: `${config[process.env.APP_ENV].apiUrl}/api/customer`,
  customerValidation: `${config[process.env.APP_ENV].apiUrl}/api/customer-validation`,
  reservations: `${config[process.env.APP_ENV].apiUrl}/api/reservations`,
  regions: `${config[process.env.APP_ENV].apiUrl}/api/regions`,
  services: `${config[process.env.APP_ENV].apiUrl}/api/services`,
  therapists: `${config[process.env.APP_ENV].apiUrl}/api/therapists`,
  appointment: `${config[process.env.APP_ENV].apiUrl}/api/appointment`,
  followUps: `${config[process.env.APP_ENV].apiUrl}/api/follow-ups`,
  therapistServices: `${config[process.env.APP_ENV].apiUrl}/api/therapist-services`,
  futureAppointments: `${config[process.env.APP_ENV].apiUrl}/api/future-appointments`,
  futureAppointment: `${config[process.env.APP_ENV].apiUrl}/api/future-appointment`,
};

export default api;
